import React, { useState, useEffect, useContext} from "react";
import { getCountry } from './../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify'; 
import GlobalContext from "../../context/GlobalContext";
import Icon from '@mui/material/Icon';

const CTA = () => {
    const gContext = useContext(GlobalContext);
    const [toggleSearchMenu, setToggleSearchMenu] = React.useState(false);
    const [searchMode, setSearchMode] = useState('expert');
    const [countriesList, setCountriesList] = useState([]);
    const [values, setValues] = React.useState({ keyword: '' });

    function toggleSearchMode(mode)
    {
        setSearchMode(mode);
        toggleSearch();
        document.getElementById("keyword").focus();

    }
    function toggleSearch() {
        let current = toggleSearchMenu;
        setToggleSearchMenu(!current);

    }
    function showSearchOption()
    {
        setToggleSearchMenu(true);
       
    }
    const handleKeyDown = (e) => {
        if (e.charCode === 13) {
           
            navigateSearch();
        }
    };
    const handleChange = (e, type) => {
        if (type == 'keyword') {
            var regex = new RegExp('[^0-9a-zA-Z-,_.\:\s ]+');

            if (!regex.test(e.target.value)) {
                setValues({ ...values, ["keyword"]: e.target.value });
            }
        }
    };
    function navigateSearch() {
        localStorage.setItem('jobSearch', JSON.stringify(values));

        let url = '/searchexpert';
        if (searchMode == 'job') {
            url = '/searchjob';
        }

        window.location.href = url;
    }
    useEffect(() => {
        getCountries();
    }, []);

    async function getCountries() {
        try {
            const result = await API.graphql(graphqlOperation(getCountry));
            let countlist = [];
            result.data.countries.map((value) => (
                countlist.push({ code: value.code, value: value.id, label: value.name })));
            setCountriesList(countlist);
            gContext.setCountriesList(countlist);

        }
        catch (e) {
           
        }
    }

    return (
        <>
            <section className="section welcome-sec bg-gray p-relative gradient-img ">
                <div className="container">
                    <div className="row align-items-start g-4">
                        <div className="col-lg-6 text-center">
                            <div className="comprehensive-block p-relative">
                                <div>
                                    <div className="comprehensive-block-title">
                                        <div className="section-title m-b-10">
                                            <h5>Most <span className="text-theme">Comprehensive Compliance</span>  Job Portal</h5>
                                        </div>
                                        {gContext.userInfo.email == '' && <>
                                            <div className="comprehensive-btn m-t-10">
                                                <button className="btn   btn-orange m-r-20" onClick={(e) => {
                                                    e.preventDefault();
                                                    gContext.toggleSignInModal();
                                                }}><Icon className="text-white m-icon material-icons">logout</Icon> <span className="text-white">Login</span></button>
                                                <button id="signup1" className="btn   btn-dark-outline" onClick={(e) => {
                                                    e.preventDefault();
                                                    gContext.toggleSignUpModal();
                                                }}><Icon className="m-icon material-icons">person</Icon> <span>Sign up</span></button>
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center">
                            <div className="section-title text-center">
                                <h5>Ready to move faster on <span className="text-theme">compliance?</span></h5>
                                <p className="section-desc">Find qualified experts in days, not months. Start now for free.</p>
                            </div>

                            <div className="search-group text-center mx-auto">
                                <div className="search-info hero-search-info p-relative text-center ">
                                    <div className="mb-0 flex-grow-1">
                                        <input type="text" className="form-control form-control-lg hero-search-input d-none d-lg-block d-xl-block d-md-block " placeholder={(searchMode == 'job') ? "Compliance Standard i.e.'ISO 9001 Consultant'" : " Compliance Standard i.e.'ISO 9001 Consultant'"} onKeyPress={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e, 'keyword')} onKeyUp={(e) => handleChange(e, 'keyword')} />

                                        <input type="text" className="form-control form-control-lg hero-search-input d-block d-sm-none " placeholder={(searchMode == 'job') ? "ISO 9001 Consultant" : "ISO 9001 Consultant"} onKeyPress={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e, 'keyword')} onKeyUp={(e) => handleChange(e, 'keyword')} />
                                    </div>
                                    <div className="ms-auto">
                                        <button type="button" onClick={() => {
                                            navigateSearch();

                                        }} className="btn btn-orange search-btn hero-search-btn rounded-circle" aria-label="Search"><i className="text-white m-icon material-icons">search</i></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CTA;